import { css } from 'lit';

export const sharedStyles = css`
  /* Inputs & Selects */
  input[type="text"],
  input[type="number"],
  input[type="search"],
  select,
  .shared-input {
    background: rgba(0, 0, 0, 0.3);
    border: 1px solid rgba(255, 255, 255, 0.15);
    border-radius: 4px;
    color: #eee;
    padding: 6px 8px;
    font-size: 11px;
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
    transition: all 0.2s;
  }

  input:focus,
  select:focus,
  .shared-input:focus {
    outline: none;
    border-color: #2196F3;
    background: rgba(0, 0, 0, 0.5);
  }

  select {
    cursor: pointer;
    appearance: none;
    background-image: url("data:image/svg+xml;charset=US-ASCII,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%22292.4%22%20height%3D%22292.4%22%3E%3Cpath%20fill%3D%22%23cccccc%22%20d%3D%22M287%2069.4a17.6%2017.6%200%200%200-13-5.4H18.4c-5%200-9.3%201.8-12.9%205.4A17.6%2017.6%200%200%200%200%2082.2c0%205%201.8%209.3%205.4%2012.9l128%20127.9c3.6%203.6%207.8%205.4%2012.8%205.4s9.2-1.8%2012.8-5.4L287%2095c3.5-3.5%205.4-7.8%205.4-12.8%200-5-1.9-9.2-5.5-12.8z%22%2F%3E%3C%2Fsvg%3E");
    background-repeat: no-repeat;
    background-position: right 8px center;
    background-size: 8px auto;
    padding-right: 24px;
  }

  select option {
    background: #222;
    color: #eee;
  }

  /* Buttons */
  button, .shared-btn {
    padding: 6px 12px;
    border: 1px solid rgba(255, 255, 255, 0.15);
    border-radius: 4px;
    background: rgba(255, 255, 255, 0.05);
    color: #eee;
    cursor: pointer;
    font-size: 11px;
    font-family: inherit;
    transition: all 0.2s;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
  }

  button:hover, .shared-btn:hover {
    background: rgba(255, 255, 255, 0.15);
    border-color: rgba(255, 255, 255, 0.3);
  }

  button:active, .shared-btn:active {
    background: rgba(255, 255, 255, 0.1);
    transform: translateY(1px);
  }

  button.active, .shared-btn.active {
    background: rgba(33, 150, 243, 0.3);
    border-color: #2196F3;
    color: #fff;
  }

  button.danger, .shared-btn.danger {
    background: rgba(244, 67, 54, 0.2);
    border-color: rgba(244, 67, 54, 0.5);
    color: #ff8a80;
  }

  button.danger:hover, .shared-btn.danger:hover {
    background: rgba(244, 67, 54, 0.4);
  }

  button.mini, .shared-btn.mini {
    padding: 2px 6px;
    font-size: 10px;
    height: 20px;
  }

  /* Labels */
  label, .shared-label {
    font-size: 11px;
    color: #aaa;
    font-weight: 500;
    margin-bottom: 4px;
    display: block;
  }

  /* Section Titles */
  .section-title {
    font-size: 10px;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    color: #888;
    font-weight: 600;
    margin: 12px 0 8px 0;
    padding-bottom: 4px;
    border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  }

  /* Pills / Badges */
  .pill {
    display: inline-block;
    padding: 2px 6px;
    border-radius: 10px;
    font-size: 10px;
    font-weight: 600;
    background: rgba(255, 255, 255, 0.1);
    color: #ccc;
    line-height: 1;
  }

  .pill.primary { background: rgba(33, 150, 243, 0.3); color: #90caf9; }
  .pill.success { background: rgba(76, 175, 80, 0.3); color: #a5d6a7; }
  .pill.warning { background: rgba(255, 152, 0, 0.3); color: #ffcc80; }
  .pill.danger { background: rgba(244, 67, 54, 0.3); color: #ef9a9a; }

  /* Layout Helpers */
  .row {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-bottom: 8px;
  }

  .col {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }

  .divider {
    height: 1px;
    background: rgba(255, 255, 255, 0.1);
    margin: 8px 0;
    width: 100%;
  }
`;
